<template lang="pug">
  div
</template>

<script>

export default {
  components: {

  },
  methods: {
    handleCallback () {
      if (this.$route.query.error) {
        const error = this.$route.query.error
        window.opener.postMessage({
          data: 'auth_failure',
          errorMsg: error
        }, '*')
      }
      else {
        window.opener.postMessage({
          data: 'auth_success',
          token: this.$route.query.token,
          subdomain: this.$route.query.subdomain
        }, '*')
      }
      parent.close()
    }
  },
  mounted () {
    console.log('heere we is', this.$route)
    this.handleCallback()
  }
}
</script>
